export const CHAT_MENU_WIDTH = 70;

export const CHAT_MOBILE_MENU_HEIGHT = 69;
export const CHAT_MOBILE_HEADER_HEIGHT = 49;

export const CHAT_INPUT_TOTAL_HEIGHT = 142;
export const CHAT_MOBILE_TOTAL_INPUT_HEIGHT = 61;
export const CHAT_INPUT_HEIGHT = 100;

export const CHAT_BYPASS_WARNING_BAR = 52;
export const CHAT_BYPASS_WARNING_BAR_MOBILE = 72; // XS(width : 600)부터

export const CHAT_DOCUMENTS_STEPPER_HEIGHT = 100;

export const CHAT_DRAWER_TITLE_BAR_HEIGHT = 49;
export const DRAWER_TITLE_BAR_HEIGHT = 49;
export const FIXED_BOTTOM_CTA_BAR_HEIGHT = 89;

export const VIEWER_TITLE_BAR_HEIGHT = 49;
export const VIEWER_LEFT_LIST_WIDTH = 300;
export const VIEWER_LIST_HEADER_HEIGHT = 60;
export const VIEWER_LIST_TABS_HEIGHT = 50;
export const VIEWER_MOBILE_DIMENSIONS_BUTTON_HEIGHT = 52;

export const GNB_HEIGHT = 61;
export const CHAT_DRAWER_FIXED_BOTTTOM_CTA_HEIGHT = 89;
export const CHAT_DRAWER_FIXED_BOTTTOM_CTA_HEIGHT_MOBILE = 81;
export const DOCUMENTS_STEPPER_HEIGHT = 100;
